const sizes = [
    {
        width: 400,
        height: 400,
        name: '40',
        price: '44,95',
        isActive: false,
        material: 'forex-circle'
    },
    {
        width: 600,
        height: 600,
        name: '60',
        price: '64,95',
        isActive: false,
        material: 'forex-circle'
    },
    {
        width: 800,
        height: 800,
        name: '80',
        price: '84,95',
        isActive: false,
        material: 'forex-circle'
    },
    {
        width: 1000,
        height: 1000,
        name: '100',
        price: '104,95',
        isActive: false,
        material: 'forex-circle'
    },
    {
        width: 1200,
        height: 1200,
        name: '120',
        price: '124,95',
        isActive: false,
        material: 'forex-circle'
    },
    {
        width: 1400,
        height: 1400,
        name: '140',
        price: '144,95',
        isActive: false,
        material: 'forex-circle'
    },
    {
        width: 400,
        height: 400,
        name: '40',
        price: '59,95',
        isActive: false,
        material: 'dibond-circle'
    },
    {
        width: 600,
        height: 600,
        name: '60',
        price: '79,95',
        isActive: false,
        material: 'dibond-circle'
    },
    {
        width: 800,
        height: 800,
        name: '80',
        price: '99,95',
        isActive: false,
        material: 'dibond-circle'
    },
    {
        width: 1000,
        height: 1000,
        name: '100',
        price: '119,95',
        isActive: false,
        material: 'dibond-circle'
    },
    {
        width: 1200,
        height: 1200,
        name: '120',
        price: '139,95',
        isActive: false,
        material: 'dibond-circle'
    },
    {
        width: 1400,
        height: 14000,
        name: '140',
        price: '159,95',
        isActive: false,
        material: 'dibond-circle'
    },
];

export default sizes;